export function isRunningInStorybook(): boolean {
  try {
    if (process.env.STORYBOOK) return true
  } catch {
    return false
  }
}

export function shouldEnableMockAdapters(): boolean {
  return process.env.NODE_ENV === 'test' || isRunningInStorybook()
}
